import React, { useContext, useEffect } from 'react';
import { Row } from '../../shared/utils';
import { Tooltip } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { DateTime } from 'luxon';

import { TokenContext } from '../../../App';
const SubmissionCard = ({
  getRiskTag,
  setFormData,
  formData,
  handleFileChange,
  getStatusTag,
  handleStatusUpdate,
  handleSaveForm,
  currentUrl,
  userRole,
  handleInputChange,
  allreviewers,
  handleSubmitForReview,
  readOnly,
  formDataLength,
}) => {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const page = queryParams.get('page');

  const [encodedAccessToken] = useContext(TokenContext);
  const decodedToken = jwtDecode(encodedAccessToken);
  userRole = decodedToken.role;

  const handleFileRemove = async fileName => {
    setFormData(prevState => ({
      ...prevState,
      [fileName]: '',
    }));
  };

  const handleOverRideInputChange = (e, type) => {
    let overRideRiskLevelName = '';
    let overRideRiskLevelDate = '';
    if (type == 'true') {
      overRideRiskLevelName = decodedToken.name;
      overRideRiskLevelDate = DateTime.now().toFormat('dd-MM-yyyy, HH:mm:ss');
    }

    setFormData(prevState => ({
      ...prevState,
      [e.target.name]: e.target.value,
      overRideRiskLevelName: overRideRiskLevelName,
      overRideRiskLevelDate: overRideRiskLevelDate,
    }));
  };

  // 获取当前有效的风险等级
  // 如果 overrideRiskSelected 为 true，则使用 overrideRiskLevel，否则使用 riskLevel
  const getCurrentRiskLevel = () => {
    return formData.overrideRiskSelected === 'true' ? formData.overrideRiskLevel : formData.riskLevel;
  };

  // 当选择覆盖风险级别时，自动设置默认值（不能和riskLevel相同）
  useEffect(() => {
    if (formData.overrideRiskSelected == 'true') {
      const riskLevels = ['Low', 'Medium', 'High'];
      const defaultRiskLevel = riskLevels.find(level => level !== formData.riskLevel);

      // 如果当前没有选择，或者选择的值和riskLevel相同，则设置默认值
      setFormData(prevState => {
        if (!prevState.overrideRiskLevel || prevState.overrideRiskLevel === prevState.riskLevel) {
          if (defaultRiskLevel) {
            return {
              ...prevState,
              overrideRiskLevel: defaultRiskLevel,
            };
          }
        }
        return prevState;
      });
    }
  }, [formData.overrideRiskSelected, formData.riskLevel, setFormData]);

  return (
    <div>
      <div className='my-3 border-2 p-1'>
        ⚠️ Do you wish to override the system-assigned risk rating? (This action will be logged)
        <label>
          <input
            className='p-1 mx-2'
            type='radio'
            name='overrideRiskSelected'
            value={true}
            checked={formData?.overrideRiskSelected == 'true'}
            onChange={e => handleOverRideInputChange(e, 'true')}
            disabled={readOnly}
          />
          Yes
        </label>
        <label>
          <input
            className='p-1 mx-2'
            type='radio'
            name='overrideRiskSelected'
            value={false}
            checked={formData?.overrideRiskSelected == 'false'}
            onChange={e => handleOverRideInputChange(e, 'false')}
            disabled={readOnly}
          />
          No
        </label>
        {formData.overrideRiskSelected == 'true' && (
          <div className='my-1'>
            <span className='my-4'> The risk level has been manually set to: </span>
            <select
              disabled={readOnly}
              value={formData.overrideRiskLevel}
              name='overrideRiskLevel'
              onChange={handleInputChange}
              className='px-1.5 py-1 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none focus:border-green-500'
            >
              <option value=''> - Select -</option>
              <option value='Low' disabled={getCurrentRiskLevel() === 'Low'}>
                Low
              </option>
              <option value='Medium' disabled={getCurrentRiskLevel() === 'Medium'}>
                Medium
              </option>
              <option value='High' disabled={getCurrentRiskLevel() === 'High'}>
                High
              </option>
            </select>
            <br />
            <textarea
              maxLength={800}
              disabled={readOnly}
              rows={2}
              value={formData?.explainManualRisk}
              placeholder={`Explain why manual risk chosen`}
              name={'explainManualRisk'}
              onChange={handleInputChange}
              className='border p-1.5 my-2 font-normal h-11/12 w-11/12'
            ></textarea>
            <p>
              {' '}
              Overriden by: {formData.overRideRiskLevelName} on {formData?.overRideRiskLevelDate && 'on'}{' '}
              {formData.overRideRiskLevelDate}{' '}
            </p>

            <span className='my-2 font-semibold'> Override Supporting Documents: </span>
            <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded mx-3'>
              Browse
              <input
                maxLength={800}
                type='file'
                name='overrideSupportingDocumentURL'
                onChange={handleFileChange}
                className='pt-3 hidden'
              />
            </label>
            {formData.overrideSupportingDocumentURL && (
              <>
                <a
                  href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.overrideSupportingDocumentURL.split('/').slice(-1)[0]}`}
                  target='_blank'
                  rel='noopener noreferrer'
                  className='text-blue-600'
                >
                  {decodeURIComponent(formData.overrideSupportingDocumentURL.split('/').slice(-1)[0])}
                </a>
                <span className='cursor-pointer' onClick={() => handleFileRemove('overrideSupportingDocumentURL')}>
                  {' '}
                  ❌{' '}
                </span>
              </>
            )}
          </div>
        )}
      </div>

      {(formData.riskLevel == 'High' ||
        (formData.overrideRiskLevel == 'High' && formData?.overrideRiskSelected == 'true')) && (
        <div className='bg-red-50 p-3 border-2 border-red-100'>
          <p className='mb-2 font-semibold'> Subsequent information request for High Risk</p> <hr />
          <Row>
            <div className='mb-4'>
              <p className='my-2 font-semibold'> Source of Wealth/Funds </p>
              {formData.sourceOfWealthDocumentURL && (
                <>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.sourceOfWealthDocumentURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600'
                  >
                    {decodeURIComponent(formData.sourceOfWealthDocumentURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('sourceOfWealthDocumentURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </>
              )}

              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='sourceOfWealthDocumentURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>

            <div className='mb-4'>
              <p className='my-2 font-semibold'> Management Support </p>
              {formData.managementSupportDocumentURL && (
                <p>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.managementSupportDocumentURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 my-2'
                  >
                    {decodeURIComponent(formData.managementSupportDocumentURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('managementSupportDocumentURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </p>
              )}
              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='managementSupportDocumentURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>

            <div className='mb-4'>
              <p className='my-2 font-semibold'> Other Documents </p>
              {formData.otherDocumentsURL && (
                <p>
                  <a
                    href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.otherDocumentsURL.split('/').slice(-1)[0]}`}
                    target='_blank'
                    rel='noopener noreferrer'
                    className='text-blue-600 my-2'
                  >
                    {/* <a href={`${process.env.REACT_APP_BACKEND_URL}/get-upload?fileName=${formData.otherDocumentsURL.split('/').slice(-1)[0]}&accessToken=${token}`} target='_blank'  rel="noopener noreferrer"  className='text-blue-600 my-2'>  */}
                    {decodeURIComponent(formData.otherDocumentsURL.split('/').slice(-1)[0])}
                  </a>
                  <span className='cursor-pointer' onClick={() => handleFileRemove('otherDocumentsURL')}>
                    {' '}
                    ❌{' '}
                  </span>
                </p>
              )}
              <label className='cursor-pointer bg-gray-200 px-1 py-0.5 mt-1 rounded'>
                Browse
                <input
                  maxLength={800}
                  type='file'
                  name='otherDocumentsURL'
                  onChange={handleFileChange}
                  className='pt-3 hidden'
                />
              </label>
            </div>
          </Row>
        </div>
      )}

      {formData?.status == 'rejected' && (
        <p className='my-5 mt-7'>
          {' '}
          Rejected at:{' '}
          <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.screenedDate} </span>{' '}
        </p>
      )}

      {formData?.status == 'accepted' && (
        <div>
          {page != 3 && (
            <p className='my-5 mt-7'>
              {' '}
              Accepted at:{' '}
              <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.screenedDate} </span>{' '}
            </p>
          )}
          {page == 3 && (
            <p className='my-5 mt-7'>
              {' '}
              Client Approved Date:{' '}
              <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.createDate} </span>{' '}
            </p>
          )}
          {page == 3 && (
            <p className='my-5 mt-7'>
              {' '}
              Next Review Date
              <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '> {formData.apiRefreshTime} </span>{' '}
            </p>
          )}
        </div>
      )}

      {/* Next Assessment Date: show whenever we have risk level (before or after accept) */}
      <p className='my-5 mt-7'>
        {' '}
        Next Assessment Date:&nbsp;&nbsp;
        <span className='bg-gray-200 py-2 px-4 border border-b-gray-300 '>
          {formData?.nextRescreeningDate ? (
            <>
              {formData.nextRescreeningDate.split('-')[0]}-{formData.nextRescreeningDate.split('-')[1]}-
              <span className='text-purple-600'>{formData.nextRescreeningDate.split('-')[2]}</span>
            </>
          ) : (
            'N/A'
          )}
        </span>
        {page != 3 && formData?.status == 'accepted' && (
          <button
            onClick={() => {
              window.location = window.location.href.replace('page=2', 'page=3');
            }}
            className='ml-5 bg-green-500 hover:bg-green-600 text-white py-2 px-4 mr-5'
          >
            To Ongoing Monitoring
          </button>
        )}
      </p>

      <p className='my-5'>
        {' '}
        Acceptance Status: <span className='text-red-500'> {getStatusTag(formData.status)} </span>{' '}
      </p>
      {page != 3 &&
        formData?.status &&
        (formData.status === 'waiting for review' || formData.status === 'rejected') &&
        formData.status !== 'accepted' &&
        userRole !== 'preparer' &&
        userRole !== 'viewer' && (
          <Row>
            {!readOnly && (
              <>
                <div className='mb-6'>
                  <button
                    className='bg-green-500 text-white py-2 px-4 mr-5 hover:bg-green-600'
                    onClick={e => handleStatusUpdate(e, 'accepted')}
                  >
                    Accept
                  </button>
                  <button
                    className={`bg-red-500 hover:bg-red-600 text-white py-2 px-4`}
                    onClick={e => {
                      handleStatusUpdate(e, 'rejected');
                    }}
                  >
                    Reject
                  </button>
                </div>
              </>
            )}
          </Row>
        )}
      {page == 3 &&
        formData?.status &&
        currentUrl !== '/form/kyc-aml' &&
        userRole !== 'preparer' &&
        userRole !== 'viewer' &&
        formDataLength > 1 && (
          <Row>
            {!readOnly && (
              <>
                <div className='mb-6'>
                  <button
                    className={`bg-red-500 hover:bg-red-600 mr-5 text-white py-2 px-4`}
                    onClick={e => {
                      handleStatusUpdate(e, 'review');
                    }}
                  >
                    review
                  </button>
                  <button
                    className='bg-green-500 text-white py-2 px-4  hover:bg-green-600'
                    onClick={e => handleStatusUpdate(e, 'save')}
                  >
                    sbumit
                  </button>
                </div>
              </>
            )}
          </Row>
        )}
      {formData?.status !== 'accepted' && currentUrl !== '/form/kyc-aml' && userRole !== 'viewer' && !readOnly && (
        <>
          <Row>
            <div>
              <select
                value={formData?.reviewerReviewEmail}
                onChange={handleInputChange}
                name='reviewerReviewEmail'
                className='p-1.5  mr-2 border-b-2 border-b-gray-300 bg-gray-100 focus:outline-none mb-3 focus:border-green-500'
              >
                <option> - Do not send Email - </option>
                {allreviewers.map(reviewer => (
                  <option key={reviewer.email} value={reviewer.email}>
                    {' '}
                    {reviewer.name} - {reviewer.email}{' '}
                  </option> // when using .map, NEED ( after arrow => ( which is a 'return statement'
                ))}
              </select>
              <button
                className='bg-green-500 hover:bg-green-600 text-white py-2 px-4 mr-1'
                onClick={handleSubmitForReview}
              >
                {' '}
                Submit for Review{' '}
              </button>
              <Tooltip
                title={
                  <p>
                    {' '}
                    This sends an email with the current url to the reviewer selected for them to review this risk
                    assessment.
                  </p>
                }
                arrow
                componentsProps={{
                  tooltip: {
                    sx: { maxWidth: '445px', fontSize: '14px' },
                  },
                }}
              >
                <span className='text-xl relative bottom-0.5'> ⓘ </span>
              </Tooltip>
            </div>
            <button className='bg-green-500 hover:bg-green-600 text-white py-2 px-4 mr-5' onClick={handleSaveForm}>
              {' '}
              Save{' '}
            </button>
          </Row>
        </>
      )}

      <Row className='mb-4 justify-end'>
        <div>
          {' '}
          Submitted by: {formData.submitPerson} {formData.submitPerson && 'on'} {formData.submitDate}{' '}
        </div>
        <div>
          {' '}
          Reviewed by: {formData.approvalPerson} {formData.approvalPerson && 'on'} {formData.approvalDate}{' '}
        </div>
      </Row>
    </div>
  );
};

export default SubmissionCard;
